import { createContext, useContext, ReactNode } from 'react';

interface StudentLessonResultContextType {
	studentId: string;
	lessonId: string;
	classId: string;
}

const StudentLessonResultContext = createContext<StudentLessonResultContextType | null>(null);

export const useStudentLessonResultContext = () => {
	const ctx = useContext(StudentLessonResultContext);
	if (!ctx) throw new Error('useStudentLessonResultContext must be used within StudentLessonResultProvider');
	return ctx;
};

export const StudentLessonResultContextProvider = ({
	children,
	studentId,
	lessonId,
	classId,
}: {
	children: ReactNode;
	studentId: string;
	lessonId: string;
	classId: string;
}) => {
	return (
		<StudentLessonResultContext.Provider value={{ studentId, lessonId, classId }}>
			{children}
		</StudentLessonResultContext.Provider>
	);
};